import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faDiagramProject, faBullseye } from '@fortawesome/free-solid-svg-icons';

function Services() {
  return (
    <section id="services" className="services">
      <div className="container">
        <h2>Was Sie mit FH Consulting erreichen können</h2>
        <p>
          Wir unterstützen Sie dabei, Klarheit ins Facility Management zu bringen –
          mit durchdachten Strategien, verlässlichen Abläufen und einem Team, das den Wandel mitträgt.
        </p>

        <div className="cards">

          {/* Strategie & Transformation */}
          <div className="service-card">
            <div className="icon">
              <FontAwesomeIcon icon={faChartLine} size="2x" />
            </div>
            <h3>Ihre Vision – strukturiert umgesetzt</h3>
            <p>
              Gemeinsam definieren wir klare Ziele und entwickeln eine Strategie, die nicht nur gut klingt,
              sondern funktioniert – damit Ihre Organisation wächst und Veränderungen gezielt angeht.
            </p>
          </div>

          {/* Prozessoptimierung */}
          <div className="service-card">
            <div className="icon">
              <FontAwesomeIcon icon={faDiagramProject} size="2x" />
            </div>
            <h3>Weniger Reibung. Mehr Wirkung.</h3>
            <p>
              Wir identifizieren, was Ihre Prozesse bremst – und bauen klare, stabile Abläufe,
              die Ihr Team entlasten und die Qualität im Tagesgeschäft nachhaltig sichern.
            </p>
          </div>

          {/* Training & Coaching */}
          <div className="service-card">
            <div className="icon">
              <FontAwesomeIcon icon={faBullseye} size="2x" />
            </div>
            <h3>Teams, die Wandel mitgestalten</h3>
            <p>
              In maßgeschneiderten Trainings und Coachings stärken wir Ihre Mitarbeitenden –
              für mehr Eigenverantwortung, neue Kompetenzen und eine Kultur, die Veränderung trägt.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Services;
